import { BodyText, Subtitle2Text } from '@/utils/global-fonts';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { FiChevronLeft, FiChevronRight, FiDownload } from 'react-icons/fi';
import { MdSkipNext } from 'react-icons/md';
import Styled from './stepper-style'; // You can add your own CSS file for styling
import PermissionWrapper from '../permission-wrapper/permission-wrapper-component';
import {
  PrimaryButton,
  PrimaryOutlineButton,
} from '../button/button-component';

const styledRightArrow = {
  marginLeft: '4px',
  cursor: 'pointer',
};

const styledLeftArrow = {
  marginRight: '4px',
  cursor: 'pointer',
};

const downloadTemplateStyledButton = {
  border: 'unset',
  backgroundColor: 'unset',
};

/**
 * @param {object} root0 - The root object containing the stepper configuration.
 * @param {Array} root0.steps - An array of steps for the stepper.
 * @param {number} root0.initialStep - The initial step index to start the stepper at.
 * @returns {JSX.Element} - The rendered Stepper component.
 */
const StepperComponent = ({ steps, initialStep = 0 }) => {
  const [currentStep, setCurrentStep] = useState(initialStep);

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  if (steps[currentStep].props.nextStep) {
    handleNext();
  }

  return (
    <Styled.Stepper>
      <Styled.Actions>
        <FiChevronLeft style={styledLeftArrow} onClick={handlePrev} />
        {steps.map((step, index) => (
          <>
            <Styled.StyledStepNumber
              key={step.key}
              active={currentStep === index}
              disabled={currentStep !== index}
            >
              <BodyText
                color={`${currentStep === index ? 'White' : '#58595b'}`}
              >
                {index + 1}
              </BodyText>
            </Styled.StyledStepNumber>
            <Styled.StepName disabled={currentStep !== index}>
              <Subtitle2Text
                color={`${currentStep !== index ? '#58595b' : 'black'}`}
              >
                {step.props.name}
              </Subtitle2Text>
            </Styled.StepName>
            {index < steps.length - 1 && <Styled.StepDivider />}
          </>
        ))}
        <FiChevronRight style={styledRightArrow} onClick={handleNext} />
      </Styled.Actions>

      <Styled.StepView>{steps[currentStep]}</Styled.StepView>
      <Styled.RowStyle>
        <PrimaryOutlineButton
          buttonWidth="fit-content"
          icon={
            steps[currentStep].props.secondaryButtonTitle !== 'Skip' ? (
              <FiDownload />
            ) : (
              <MdSkipNext size={16} />
            )
          }
          disabled={false}
          margin="0 0 0 0"
          type={
            steps[currentStep].props.secondaryButtonTitle !== 'Skip'
              ? 'button'
              : 'submit'
          }
          style={
            steps[currentStep].props.secondaryButtonTitle !== 'Skip'
              ? downloadTemplateStyledButton
              : {}
          }
          loading={steps[currentStep].props.loading}
          title={steps[currentStep].props.secondaryButtonTitle}
          onClick={() => {
            steps[currentStep].props.onSecondaryClick();
          }}
        />
        <PermissionWrapper
          permissions={['price.create', 'price.read', 'price.update']}
          satisfyAll={false}
        >
          <PrimaryButton
            buttonWidth="108px"
            disabled={steps[currentStep].props.loading}
            margin="0 0 0 0"
            type={
              steps[currentStep].props.primaryButtonTitle === 'Import'
                ? 'button'
                : 'submit'
            }
            loading={steps[currentStep].props.loading}
            title={steps[currentStep].props.primaryButtonTitle}
            onClick={() => {
              steps[currentStep].props.onPrimaryClick();
            }}
          />
        </PermissionWrapper>
      </Styled.RowStyle>
    </Styled.Stepper>
  );
};

export default StepperComponent;

StepperComponent.defaultProps = {
  initialStep: 0,
};

StepperComponent.propTypes = {
  steps: PropTypes.array.isRequired,
  initialStep: PropTypes.number,
};
